import { useState } from "react";

import { api } from "../api";
import { haptic } from "../tg";

type Props = {
  blockId: string;
  itemIndex: number;
  title: string | null;
  caption: string | null;
  maxCount: number;
  initialCount: number;
};

type CountResponse = {
  block_id: string;
  item_index: number;
  count: number;
};

export default function VideoTaskCounter({
  blockId,
  itemIndex,
  title,
  caption,
  maxCount,
  initialCount,
}: Props) {
  const [count, setCount] = useState(Math.min(initialCount, maxCount));
  const [busy, setBusy] = useState(false);

  const change = async (op: "inc" | "dec") => {
    if (busy) return;
    // Оптимистично clamp на клиенте, чтобы кнопки не лагали.
    if (op === "inc" && count >= maxCount) return;
    if (op === "dec" && count <= 0) return;
    setBusy(true);
    try {
      const res = await api<CountResponse>(`/lesson/video_record/${op}`, {
        method: "POST",
        body: JSON.stringify({ block_id: blockId, item_index: itemIndex }),
      });
      setCount(res.count);
      haptic("success");
    } catch (e) {
      haptic("error");
      console.warn("video counter change failed:", (e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="video-task-counter">
      <div className="video-task-counter-head">
        <span className="video-task-counter-icon" aria-hidden="true">🎥</span>
        {title && <span className="video-task-counter-title">{title}</span>}
      </div>
      {caption && <p className="video-task-counter-caption">{caption}</p>}
      <div className="video-task-counter-row">
        <button
          type="button"
          className="video-task-counter-btn"
          onClick={() => change("dec")}
          disabled={busy || count <= 0}
          aria-label="Уменьшить счётчик"
        >
          −
        </button>
        <span className="video-task-counter-value">
          {count} / {maxCount}
        </span>
        <button
          type="button"
          className="video-task-counter-btn"
          onClick={() => change("inc")}
          disabled={busy || count >= maxCount}
          aria-label="Увеличить счётчик"
        >
          +
        </button>
      </div>
    </div>
  );
}
